import React from 'react';
import PageTitle from '../components/Other/PageTitle/PageTitle';

const Price = () => {
  return (
    <div>
      <PageTitle title={'Услуги и цены'} />
      <h1>Цены</h1>
    </div>
  );
};

export default Price; 